import React from "react";
import { FacebookIconStroy, TwitterIconStroy, WhatsAppIconStroy } from "../Icons/Icon.js";
export default function SocialShare({ url, headline }) {
  const encodedUrl = encodeURIComponent(url); // Encode URL for safe sharing
  const encodedHeadline = encodeURIComponent(headline); // Encode headline for safe sharing

  return (
    <div className="flex gap-2">
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} target="_blank" rel="noopener noreferrer">
        <FacebookIconStroy />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedHeadline}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <TwitterIconStroy />
      </a>

      <a href={`https://wa.me/?text=${encodedUrl} ${encodedHeadline}`} target="_blank" rel="noopener noreferrer">
        <WhatsAppIconStroy />
      </a>
    </div>
  );
}
